import blueOnTransparent from 'Assets/svg/qrcode/heart_blue_on_transparent.svg'
import blueOnWhite from 'Assets/svg/qrcode/heart_blue_on_white.svg'
import whiteOnBlue from 'Assets/svg/qrcode/heart_white_on_blue.svg'
import qrDonaNoTextColourOnTransparent from 'Assets/svg/qrcode/qr_dona_notext/dona_color_on_transparent.svg'
import qrDonaNoTextColourOnWhite from 'Assets/svg/qrcode/qr_dona_notext/dona_color_on_white.svg'
import qrDonaNoTextWhiteOnColour from 'Assets/svg/qrcode/qr_dona_notext/dona_white_on_color.svg'
import qrStandardNoTextBagColourOnTransparent from 'Assets/svg/qrcode/qr_standard_notext/bag/bag_color_on_transparent.svg'
import qrStandardNoTextBagColourOnWhite from 'Assets/svg/qrcode/qr_standard_notext/bag/bag_color_on_white.svg'
import qrStandardNoTextBagWhiteOnColour from 'Assets/svg/qrcode/qr_standard_notext/bag/bag_white_on_color.svg'
import qrStandardNoTextChefColourOnTransparent from 'Assets/svg/qrcode/qr_standard_notext/chef/chef_color_on_transparent.svg'
import qrStandardNoTextChefColourOnWhite from 'Assets/svg/qrcode/qr_standard_notext/chef/chef_color_on_white.svg'
import qrStandardNoTextChefWhiteOnColour from 'Assets/svg/qrcode/qr_standard_notext/chef/chef_white_on_color.svg'
import qrStandardNoTextShopColourOnTransparent from 'Assets/svg/qrcode/qr_standard_notext/shop/shop_color_on_transparent.svg'
import qrStandardNoTextShopColourOnWhite from 'Assets/svg/qrcode/qr_standard_notext/shop/shop_color_on_white.svg'
import qrStandardNoTextShopWhiteOnColour from 'Assets/svg/qrcode/qr_standard_notext/shop/shop_white_on_color.svg'
import qrStandardNoTextTruckColourOnTransparent from 'Assets/svg/qrcode/qr_standard_notext/truck/truck_color_on_transparent.svg'
import qrStandardNoTextTruckColourOnWhite from 'Assets/svg/qrcode/qr_standard_notext/truck/truck_color_on_white.svg'
import qrStandardNoTextTruckWhiteOnColour from 'Assets/svg/qrcode/qr_standard_notext/truck/truck_white_on_color.svg'
import previewQrCode from 'Assets/svg/qrcode/qrcode_preview.svg'
import colourOnTransparent from 'Assets/svg/qrcode/square_colour_on_transparent.svg'
import colourOnWhite from 'Assets/svg/qrcode/square_colour_on_white.svg'
import whiteOnColour from 'Assets/svg/qrcode/square_white_on_colour.svg'
import formattedMessage, { messages } from './languageModule'

export const QR_CODE_COLORS = {
  default: '#000000',
  white: '#FFFFFF',
  nexi: '#333F92'
}

export const QR_CODE_FORMATS = [
  { value: 'PNG', label: 'PNG' },
  { value: 'SVG', label: 'SVG' }
]

const previewImages = {
  DONAITALIA: {
    HEART: {
      BLUE_ON_WHITE: qrDonaNoTextColourOnWhite,
      WHITE_ON_BLUE: qrDonaNoTextWhiteOnColour,
      BLUE_ON_TRANSPARENT: qrDonaNoTextColourOnTransparent
    }
  },
  STANDARD: {
    TRUCK: {
      COLOUR_ON_WHITE: qrStandardNoTextTruckColourOnWhite,
      WHITE_ON_COLOUR: qrStandardNoTextTruckWhiteOnColour,
      COLOUR_ON_TRANSPARENT: qrStandardNoTextTruckColourOnTransparent
    },
    SHOP: {
      COLOUR_ON_WHITE: qrStandardNoTextShopColourOnWhite,
      WHITE_ON_COLOUR: qrStandardNoTextShopWhiteOnColour,
      COLOUR_ON_TRANSPARENT: qrStandardNoTextShopColourOnTransparent
    },
    BAG: {
      COLOUR_ON_WHITE: qrStandardNoTextBagColourOnWhite,
      WHITE_ON_COLOUR: qrStandardNoTextBagWhiteOnColour,
      COLOUR_ON_TRANSPARENT: qrStandardNoTextBagColourOnTransparent
    },
    CHEF: {
      COLOUR_ON_WHITE: qrStandardNoTextChefColourOnWhite,
      WHITE_ON_COLOUR: qrStandardNoTextChefWhiteOnColour,
      COLOUR_ON_TRANSPARENT: qrStandardNoTextChefColourOnTransparent
    }
    // CART: {
    //   COLOUR_ON_WHITE: qrStandardNoTextCartColourOnWhite,
    //   WHITE_ON_COLOUR: qrStandardNoTextCartWhiteOnColour,
    //   COLOUR_ON_TRANSPARENT: qrStandardNoTextCartColourOnTransparent
    // },
  }
}

const standardPreviewClasses = {
  CHEF: {
    sample: 'qrcode_previewContainer_qrCode_sample_chef',
    text: 'qrcode_previewContainer_qrCode_standard_chef_text'
  },
  SHOP: {
    sample: 'qrcode_previewContainer_qrCode_sample_shop',
    text: 'qrcode_previewContainer_qrCode_standard_shop_text'
  },
  TRUCK: {
    sample: 'qrcode_previewContainer_qrCode_sample_truck',
    text: 'qrcode_previewContainer_qrCode_standard_truck_text'
  },
  BAG: {
    sample: 'qrcode_previewContainer_qrCode_sample_bag',
    text: 'qrcode_previewContainer_qrCode_standard_bag_text'
  },
  // CART: {
  //   sample: 'qrcode_previewContainer_qrCode_sample_cart',
  //   text: 'qrcode_previewContainer_qrCode_standard_cart_text'
  // }
}

const backgroundOptions = {
  DONAITALIA: [
    [blueOnWhite, formattedMessage.blueOnWhite, 'BLUE_ON_WHITE', messages.blueOnWhite],
    [whiteOnBlue, formattedMessage.whiteOnBlue, 'WHITE_ON_BLUE', messages.whiteOnBlue],
    [blueOnTransparent, formattedMessage.blueOnTransparent, 'BLUE_ON_TRANSPARENT', messages.blueOnTransparent]
  ],
  STANDARD: [
    [colourOnWhite, formattedMessage.colourOnWhite, 'COLOUR_ON_WHITE', messages.colourOnWhite],
    [whiteOnColour, formattedMessage.whiteOnColour, 'WHITE_ON_COLOUR', messages.whiteOnColour],
    [colourOnTransparent, formattedMessage.colourOnTransparent, 'COLOUR_ON_TRANSPARENT', messages.colourOnTransparent]
  ]
}

export const QR_CODE_VARIANTS = {
  DONAITALIA: {
    initialBackground: 'BLUE_ON_WHITE',
    initialShape: 'HEART',
    whiteBackground: 'WHITE_ON_BLUE',
    aspectDescription: formattedMessage.aspectDescriptionDonaItalia,
    backgroundOptions: backgroundOptions.DONAITALIA,
    previewImages: previewImages.DONAITALIA,
    previewClasses: {},
    hasShapeSelect: false,
    hasCustomColor: false,
    alwaysShowSample: true,
    useOriginalMainPreview: true
  },
  STANDARD: {
    initialBackground: 'COLOUR_ON_WHITE',
    initialShape: 'NONE',
    whiteBackground: 'WHITE_ON_COLOUR',
    aspectDescription: formattedMessage.aspectDescriptionStandard,
    backgroundOptions: backgroundOptions.STANDARD,
    previewImages: previewImages.STANDARD,
    previewClasses: standardPreviewClasses,
    hasShapeSelect: true,
    hasCustomColor: true,
    alwaysShowSample: false,
    useOriginalMainPreview: false
  }
}

export const QR_CODE_PREVIEW_IMAGE = previewQrCode
